<template>
    <div class="text-align-center">
        <h1 style="font-size: 96px">{{ 404 }}</h1>
        <div style="font-size: 36px">{{ $t('Page Not Found') }}</div>
        <el-button type="primary" class="mt-2" @click="$router.go(-2)">{{
            $t('Go Back')
        }}</el-button>
    </div>
</template>

<script>
export default {
    name: 'fourofour',
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {},
};
</script>

<style lang="scss"></style>
